// plan-04 S01: v1 verdicts table (verbatim) — bible S20

export const VERDICTS: ReadonlyArray<readonly [number, string, string]> = [
  [6,  'level-high', 'the system cannot confirm this reading'],
  [12, 'level-high', 'consensus has not been reached'],
  [18, 'level-mid',  'this pattern has been seen before'],
  [24, 'level-mid',  'proceed with partial understanding'],
  [30, 'level-low',  'something is watching this calculation'],
  [36, 'level-low',  'the reading is stable. that is not good.'],
  [99, 'level-low',  'do not share this result with others'],
] as const
